import React, { MouseEventHandler } from "react";

import { Action, Category } from "@/constants/events";
import FulfillmentMode from "@/custom-types/FulfillmentMode";
import { useEventTracker } from "@/hooks/useEventTracker";
import useWindowSize from "@/hooks/useWindowSize";
import { useSelector } from "@/redux/hooks";
import {
  getIsValidStreetAddress,
  getLocationState,
} from "@/redux/selectors/location";

import AddressCaptureModal from "@/components/AddressCaptureModal";
import ChevronIcon from "@/components/Icons/ChevronIcon";
import IconSvg from "@/components/IconSvg";
import TrackImpression from "@/components/TrackImpression";

const FulfillmentInfoBanner = ({
  fulfillmentMode,
  fullWidthBanner,
  eventCategory = Category.deliveryGateFlow,
}: {
  fulfillmentMode: FulfillmentMode;
  fullWidthBanner?: boolean;
  eventCategory?: Category;
}) => {
  const [modalVisible, setModalVisible] = React.useState(false);
  const modalReturnRef = React.createRef<HTMLButtonElement>();
  const location = useSelector(getLocationState);
  const isValidAddress = useSelector(getIsValidStreetAddress);
  const { publishEvent } = useEventTracker();

  const handleClick: MouseEventHandler = (ev) => {
    ev.preventDefault();
    publishEvent({
      action: Action.click,
      category: eventCategory,
      label: "address bar",
    });
    setModalVisible(true);
  };

  const isDeliveryMode = fulfillmentMode === "delivery";
  const fulfillmentLabel = isDeliveryMode ? "Deliver now to" : "Pickup near";
  const iconFileName = isDeliveryMode ? "scooter.svg" : "store.svg";
  const { isMobile } = useWindowSize();

  return (
    <div className={isMobile || fullWidthBanner ? "w-full" : "container"}>
      <AddressCaptureModal
        isVisible={modalVisible}
        onDismissed={() => setModalVisible(false)}
        returnFocusRef={modalReturnRef}
        isDeliveryMode={isDeliveryMode}
      />
      <TrackImpression category={eventCategory} label="address bar">
        <div
          style={{ background: "#45606E" }}
          className="flex items-center justify-center text-center text-xs text-white py-md font-bold"
        >
          <div className="mr-1 min-h-[16px] min-w-[16px]">
            <IconSvg
              svgClassName="inline-block"
              width="16"
              height="16"
              filePath={iconFileName}
            />
          </div>
          <span className="pr-[5px] mt-1">{fulfillmentLabel}</span>
          <button
            onClick={handleClick}
            ref={modalReturnRef}
            className="button--text text-left text-white font-bold underline mt-1"
            data-testid="delivery-validation-btn-info-bar"
          >
            {isValidAddress && location.street
              ? `${location.street.number} ${location.street.name}`
              : `${location.formattedLocation}`}
            <ChevronIcon
              className="text-white inline ml-1"
              width="16"
              height="16"
            />
          </button>
        </div>
      </TrackImpression>
    </div>
  );
};

export default FulfillmentInfoBanner;
